module.exports = __webpack_public_path__ + "img/redStamp.50299f0e.png";